import { render, staticRenderFns } from "./ValoraCards.vue?vue&type=template&id=521a16d6&scoped=true&"
import script from "./ValoraCards.vue?vue&type=script&lang=js&"
export * from "./ValoraCards.vue?vue&type=script&lang=js&"
import style0 from "./ValoraCards.vue?vue&type=style&index=0&id=521a16d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521a16d6",
  null
  
)

export default component.exports